import {O} from "web-vcore";
import {ignore} from "mobx-sync";
import {CorpusSortBy} from "../../../EchoHunt/CorpusSort.js";

export enum EchoHuntTab {
	play = "play",
	story = "story",
	corpus = "corpus",
	worlds = "worlds",
	characters = "characters",
	cliches = "cliches",
	settings = "settings",
}

export class EchoHuntState {
	@O accessor tab = EchoHuntTab.play;

	// story tab (view settings)
	// ==========

	/** Which story the Story tab is SHOWING. Deliberately `@ignore`d (not persisted) and separate from
	 * `echoProfiles.activeStoryId`, which is which run the PLAY tab builds into. */
	@O @ignore accessor storyBeingEdited: string|n = null;

	// corpus tab (view settings)
	// ==========

	/** How the Corpus tab orders its rows. Persisted (via mobx-sync) with the rest of the store tree,
	 * so it survives a reload -- it is a view preference, so it does not belong in `echoProfiles`. */
	@O accessor corpusSortBy = "dreamDate" as CorpusSortBy;
	@O accessor corpusSortDescending = false;

	/** Corpus-tab filters, kept here for the same reason (they are cheap view state, and losing them on
	 * every tab switch is annoying). */
	@O accessor corpusFilterReason = "(all)";
	@O accessor corpusFilterEventType = "(all)";
	@O accessor corpusSearch = "";
	@O accessor corpusShowRaw = false;
}
